import R from 'ramda'

const MOSAIC_OPT_OUT_ACTION_TYPE = 'MOSAIC_OPT_OUT'
const MOSAIC_OPT_OUT_DISPLAY_TYPE = 'Mosaic opt out'

const isMosaicOptOutFormAction = R.propEq('type', MOSAIC_OPT_OUT_DISPLAY_TYPE)

const convertMosaicOptOutFormActionToWidgetAction = R.applySpec({
  type: R.always(MOSAIC_OPT_OUT_ACTION_TYPE)
})

export { isMosaicOptOutFormAction, convertMosaicOptOutFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/mosaic-opt-out.js